export default __webpack_public_path__ + "static/media/mz.5851c957.svg";